import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import categoryBotResponseCodeMapping from '../../../../../../data/categoryBotResponseCodeMapping';
import drBotResponseCodeMapping from '../../../../../../data/drBotResponseCodeMapping';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  postAPI_Create_Services,
  gAPI_Service_By_Id,
  putAPI_Update_Service,
  putAPI_Delete_Service,
} from '../../../../../../constants/APIs';
import ImageGallery from '../../gallery/index';
import Select from 'react-select';
export function AddNewService({
  id,
  visible,
  toggleModal,
  formLabel,
  propertyId,
  domains,
}) {
  const [titleToolTip, settitleToolTip] = useState(false);
  const [typeToolTip, setTypeToolTip] = useState(false);
  const [priceToolTip, setpriceToolTip] = useState(false);
  const [categoryToolTip, setCategoryToolTip] = useState(false);
  const [selectedOptions, setselectedOptions] = useState([]);
  const [selectedcategories, setselectedcategories] = useState([]);
  const [isDoctor, setIsDoctor] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [qbot, setQbot] = useState(false);

  const categoriesData = [
    { label: "Women's Cut & Trims", value: "Women's Cut & Trims", key: 0 },
    { label: 'Hairs Foils', value: 'Hairs Foils', key: 1 },
    { label: 'Hair Color', value: 'Hair Color', key: 2 },
    { label: 'Hair Highlights', value: 'Hair Highlights', key: 3 },
    { label: 'Hair Tint & Toner', value: 'Hair Tint & Toner', key: 4 },
    { label: 'Hair Blow Wave', value: 'Hair Blow Wave', key: 5 },
    { label: 'Hair Straightening', value: 'Hair Straightening', key: 6 },
    { label: 'Shampoo', value: 'Shampoo', key: 7 },
    { label: 'Hair Perm', value: 'Hair Perm', key: 8 },
    { label: 'Hair Extensions', value: 'Hair Extensions', key: 9 },
    { label: 'Keratin Smoothening', value: 'Keratin Smoothening', key: 10 },
    { label: "Men's Cut", value: "Men's Cut", key: 11 },
    { label: "Men's Shave", value: "Men's Shave", key: 12 },
    { label: "Men's Beard", value: "Men's Beard", key: 13 },
    { label: 'Children Hair Cut', value: 'Children Hair Cut', key: 14 },
    { label: 'Waxing', value: 'Waxing', key: 15 },
    { label: 'Threading', value: "Women's Cut & Trims", key: 16 },
    { label: 'Brazillian Wax', value: 'Brazillian Wax', key: 17 },
    {
      label: 'Eyebrow/Eyelash Tinting',
      value: 'Eyebrow/Eyelash Tinting',
      key: 18,
    },
    { label: 'Tanning', value: 'Tanning', key: 19 },
    { label: 'Facials', value: 'Facials', key: 20 },
    { label: 'Piercing', value: 'Piercing', key: 21 },
    { label: 'Manicure', value: 'Manicure', key: 22 },
    { label: 'Pedicure', value: 'Pedicure', key: 23 },
    { label: 'Massage', value: 'Massage', key: 24 },
    { label: 'Make-up', value: 'Make-up', key: 25 },
    { label: 'Coffee Sachets', value: 'Coffee Sachets', key: 26 },
    { label: 'Tea Bags', value: 'Tea Bags', key: 27 },
    { label: 'Sugar Sachets', value: 'Sugar Sachets', key: 28 },
    { label: 'Milk Tubs', value: 'Milk Tubs', key: 29 },
    { label: 'Toilet Paper', value: 'Toilet Paper', key: 30 },
    { label: 'Shampoo', value: 'Shampoo', key: 31 },
    { label: 'Conditioner', value: 'Conditioner', key: 32 },
    { label: 'Body Wash', value: 'Body Wash', key: 33 },
    { label: 'Hand Wash', value: 'Hand Wash', key: 34 },
    { label: 'Toothpaste', value: 'Toothpaste', key: 35 },
    { label: 'Toothbrush', value: 'Toothbrush', key: 36 },
    { label: 'Shaving Kit', value: 'Shaving Kit', key: 37 },
    { label: 'Room Cleaning', value: 'Room Cleaning', key: 38 },
    { label: 'Towels', value: 'Towels', key: 39 },
    { label: 'Barista Coffee', value: 'Barista Coffee', key: 40 },
    { label: 'Smoothies', value: 'Smoothies', key: 41 },
    { label: 'Bottled Water', value: 'Bottled Water', key: 42 },
    { label: 'Soft Drinks', value: 'Soft Drinks', key: 43 },
    { label: 'Physiotherapy', value: 'Physiotherapy', key: 44 },
    { label: 'Rehabilitation', value: 'Rehabilitation', key: 45 },
    { label: 'Wellbeing', value: 'Wellbeing', key: 46 },
    { label: 'Acupuncture', value: 'Acupuncture', key: 47 },
    { label: 'Pelvic Health', value: 'Pelvic Health', key: 48 },
    { label: 'Psychology', value: 'Psychology', key: 49 },
    { label: 'Concussion', value: 'Concussion', key: 50 },
    {
      label: 'Occupational Assessment',
      value: 'Occupational Assessment',
      key: 51,
    },
    { label: 'Nutrition', value: 'Nutrition', key: 52 },
    {
      label: 'Speech & Language Therapy',
      value: 'Speech & Language Therapy',
      key: 53,
    },
    { label: 'Workshops', value: 'Workshops', key: 54 },
    { label: 'Sports', value: 'Sports', key: 55 },
    { label: 'ACC & WINZ Services', value: 'ACC & WINZ Services', key: 56 },
    { label: 'Exercise & Training', value: 'Exercise & Training', key: 57 },
    { label: 'Dental Exam & X-Rays', value: 'Dental Exam & X-Rays', key: 58 },
    {
      label: 'Dental Crowns & Bridges',
      value: 'Dental Crowns & Bridges',
      key: 59,
    },
    { label: 'Braces & Invisalign', value: 'Braces & Invisalign', key: 60 },
    {
      label: 'Dental Crowns & Bridges',
      value: 'Dental Crowns & Bridges',
      key: 61,
    },
    { label: 'Dentures', value: 'Dentures', key: 62 },
    { label: 'Teeth Extraction', value: 'Teeth Extraction', key: 63 },
    { label: 'Mouth Guards', value: 'Mouth Guards', key: 64 },
    { label: 'Dentofacial', value: 'Dentofacial', key: 65 },
    { label: 'Dental Implants', value: 'Dental Implants', key: 66 },
    { label: 'Dental Hygiene', value: 'Dental Hygiene', key: 67 },
    { label: 'Root Canal', value: 'Root Canal', key: 68 },
    { label: 'Tooth Whitening', value: 'Tooth Whitening', key: 69 },
    { label: 'Kids Dental', value: 'Kids Dental', key: 70 },
  ];
  const salonCategoriesData = [
    { label: "Women's Cut & Trims", value: "Women's Cut & Trims", key: 0 },
    { label: 'Hairs Foils', value: 'Hairs Foils', key: 1 },
    { label: 'Hair Color', value: 'Hair Color', key: 2 },
    { label: 'Hair Highlights', value: 'Hair Highlights', key: 3 },
    { label: 'Hair Tint & Toner', value: 'Hair Tint & Toner', key: 4 },
    { label: 'Hair Blow Wave', value: 'Hair Blow Wave', key: 5 },
    { label: 'Hair Straightening', value: 'Hair Straightening', key: 6 },
    { label: 'Shampoo', value: 'Shampoo', key: 7 },
    { label: 'Hair Perm', value: 'Hair Perm', key: 8 },
    { label: 'Hair Extensions', value: 'Hair Extensions', key: 9 },
    { label: 'Keratin Smoothening', value: 'Keratin Smoothening', key: 10 },
    { label: "Men's Cut", value: "Men's Cut", key: 11 },
    { label: "Men's Shave", value: "Men's Shave", key: 12 },
    { label: "Men's Beard", value: "Men's Beard", key: 13 },
    { label: 'Children Hair Cut', value: 'Children Hair Cut', key: 14 },
    { label: 'Waxing', value: 'Waxing', key: 15 },
    { label: 'Threading', value: "Women's Cut & Trims", key: 16 },
    { label: 'Brazillian Wax', value: 'Brazillian Wax', key: 17 },
    {
      label: 'Eyebrow/Eyelash Tinting',
      value: 'Eyebrow/Eyelash Tinting',
      key: 18,
    },
    { label: 'Tanning', value: 'Tanning', key: 19 },
    { label: 'Facials', value: 'Facials', key: 20 },
    { label: 'Piercing', value: 'Piercing', key: 21 },
    { label: 'Manicure', value: 'Manicure', key: 22 },
    { label: 'Pedicure', value: 'Pedicure', key: 23 },
    { label: 'Massage', value: 'Massage', key: 24 },
    { label: 'Make-up', value: 'Make-up', key: 25 },
  ];
  const GuestServicesCategoriesData = [
    { label: 'Coffee Sachets', value: 'Coffee Sachets', key: 0 },
    { label: 'Tea Bags', value: 'Tea Bags', key: 1 },
    { label: 'Sugar Sachets', value: 'Sugar Sachets', key: 2 },
    { label: 'Milk Tubs', value: 'Milk Tubs', key: 3 },
    { label: 'Toilet Paper', value: 'Toilet Paper', key: 4 },
    { label: 'Shampoo', value: 'Shampoo', key: 5 },
    { label: 'Conditioner', value: 'Conditioner', key: 6 },
    { label: 'Body Wash', value: 'Body Wash', key: 7 },
    { label: 'Hand Wash', value: 'Hand Wash', key: 8 },
    { label: 'Toothpaste', value: 'Toothpaste', key: 9 },
    { label: 'Toothbrush', value: 'Toothbrush', key: 10 },
    { label: 'Shaving Kit', value: 'Shaving Kit', key: 11 },
    { label: 'Room Cleaning', value: 'Room Cleaning', key: 12 },
    { label: 'Towels', value: 'Towels', key: 13 },
    { label: 'Barista Coffee', value: 'Barista Coffee', key: 14 },
    { label: 'Smoothies', value: 'Smoothies', key: 15 },
    { label: 'Bottled Water', value: 'Bottled Water', key: 16 },
    { label: 'Soft Drinks', value: 'Soft Drinks', key: 17 },
  ];
  const DoctorServicesCategoriesData = [
    { label: 'Physiotherapy', value: 'Physiotherapy', key: 0 },
    { label: 'Rehabilitation', value: 'Rehabilitation', key: 1 },
    { label: 'Wellbeing', value: 'Wellbeing', key: 2 },
    { label: 'Acupuncture', value: 'Acupuncture', key: 3 },
    { label: 'Pelvic Health', value: 'Pelvic Health', key: 4 },
    { label: 'Psychology', value: 'Psychology', key: 5 },
    { label: 'Concussion', value: 'Concussion', key: 6 },
    {
      label: 'Occupational Assessment',
      value: 'Occupational Assessment',
      key: 7,
    },
    { label: 'Nutrition', value: 'Nutrition', key: 8 },
    {
      label: 'Speech & Language Therapy',
      value: 'Speech & Language Therapy',
      key: 9,
    },
    { label: 'Workshops', value: 'Workshops', key: 10 },
    { label: 'Sports', value: 'Sports', key: 11 },
    { label: 'ACC & WINZ Services', value: 'ACC & WINZ Services', key: 12 },
    { label: 'Exercise & Training', value: 'Exercise & Training', key: 13 },
    { label: 'Dental Exam & X-Rays', value: 'Dental Exam & X-Rays', key: 14 },
    {
      label: 'Dental Crowns & Bridges',
      value: 'Dental Crowns & Bridges',
      key: 15,
    },
    { label: 'Braces & Invisalign', value: 'Braces & Invisalign', key: 16 },
    {
      label: 'Dental Crowns & Bridges',
      value: 'Dental Crowns & Bridges',
      key: 17,
    },
    { label: 'Dentures', value: 'Dentures', key: 18 },
    { label: 'Teeth Extraction', value: 'Teeth Extraction', key: 19 },
    { label: 'Mouth Guards', value: 'Mouth Guards', key: 20 },
    { label: 'Dentofacial', value: 'Dentofacial', key: 21 },
    { label: 'Dental Implants', value: 'Dental Implants', key: 22 },
    { label: 'Dental Hygiene', value: 'Dental Hygiene', key: 23 },
    { label: 'Root Canal', value: 'Root Canal', key: 24 },
    { label: 'Tooth Whitening', value: 'Tooth Whitening', key: 25 },
    { label: 'Kids Dental', value: 'Kids Dental', key: 26 },
  ];

  const typeTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service</b> is one service like Dental Exam & Xray.
          <br /> <b>Package </b> is a service bundle offering multiple services
          for sale as a one combined service package.
          <br /> <b>Special Offer </b> is certain special value you can offer to
          your client.
        </Tooltip>
      );
    } else if (qbot) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Room Service</b> is a food or beverage order that a guest can place
          to be delivered to the room.
          <br /> <b>Housekeeping</b> is something guest can ask for the room,
          like cleaning, replacing towels, toiletries etc.
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service</b> is one service like haircut, hair color and head
          message.
          <br /> <b>Package</b> is service bundle offering multiple services for
          sale as one combined service package.
          <br /> Special <b>Offer</b> is certain special value you can offer to
          your client.
        </Tooltip>
      );
    }
  };

  const priceChangeTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and
          depends on the specific needs.
        </Tooltip>
      );
    } else if (qbot) {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and depend
          upon different conditions like hair length, thickness etc.
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and depend
          upon different conditions like hair length, thickness etc.
        </Tooltip>
      );
    }
  };

  const categoryTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={categoryToolTip}
          target="categoryToolTip"
          toggle={toggleCategoryToolTip}
        >
          Select the closest one or multiple categories that apply to this
          service, package or offer.
        </Tooltip>
      );
    }
  };

  const generatorCategorySelect = () => {
    if (isDoctor) {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={DoctorServicesCategoriesData}
        />
      );
    } else if (qbot) {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={GuestServicesCategoriesData}
        />
      );
    } else {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={salonCategoriesData}
        />
      );
    }
  };

  // useEffect(() => {
  //   if (id !== undefined) {
  //     console.log('in');
  //     AxiosAPI({
  //       method: 'get',
  //       url: `${gAPI_Service_By_Id}/${id}`,
  //     })
  //       .then((res) => {
  //         setServiceData(res.data);
  //         var selectedcategories = [];
  //         try {
  //           res.data.categories.map((item) =>
  //             selectedcategories.push(
  //               categoriesData.filter((cat) => cat.value === item)[0]
  //             )
  //           );
  //         } finally {
  //         }
  //         setselectedOptions(selectedcategories);
  //         setselectedcategories(selectedcategories);
  //       })
  //       .catch((err) => console.log('err', err));
  //   }
  // }, [qbot, isDoctor]);

  if (Array.isArray(domains) && qbot === false) {
    // console.log("domains", domains);
    domains.forEach((r) => {
      if (r.type === 'QuarantineBot') {
        setQbot(true);
      }
    });
  }

  if (Array.isArray(domains) && isDoctor === false) {
    // console.log("domains", domains);
    domains.forEach((r) => {
      if (r.type === 'Doctors') {
        setIsDoctor(true);
      }
    });
  }

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    setServiceData({
      ...serviceData,
      imageLink: image.src,
    });
  };

  const handleRemoveImage = () => {
    setServiceData({
      ...serviceData,
      imageLink: '',
    });
  };

  const [serviceData, setServiceData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    type: 'Package',
    title: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    displayText: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    conditions: [
      {
        statement: '',
        languageCode: 'en',
      },
    ],
    status: 'Active',
    currency: 'NZD',
    priceRangeStart: 0,
    priceRangeEnd: 0,
    taxIncluded: true,
    categories: [],
    displayOrder: 1,
    creator: 'dashboard',
    imageData: '',
    imageLink: '',
    luisIntent: '',
    luisEntityKey: '',
    luisEntityValue: '',
  });

  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Service_By_Id}/${id}`,
      })
        .then((res) => {
          setServiceData(res.data);
          var selectedcategories = [];
          try {
            res.data.categories.map((item) =>
              selectedcategories.push(
                categoriesData.filter((cat) => cat.value === item)[0]
              )
            );
          } finally {
          }
          setselectedOptions(selectedcategories);
          setselectedcategories(selectedcategories);
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);

  const handleChangeMulti = (selectedOptions) => {
    setselectedOptions(selectedOptions);
    const categoriesArr = selectedOptions.map((elem) => elem.value);
    setServiceData({
      ...serviceData,
      categories: categoriesArr,
    });
  };

  const handleChange = (e) => {
    setServiceData({
      ...serviceData,
      [e.target.name]: e.target.value,
    });
  };

  // const getFiles = (files) => {
  //     setServiceData({
  //         ...serviceData,
  //         imageData: files.base64.split(",")[1],
  //     });
  // }

  const handleChangeArr = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setServiceData({
      ...serviceData,
      [key]: [
        {
          statement: value,
          languageCode: 'en',
        },
      ],
    });
  };
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  const toggleTypeToolTip = () => {
    setTypeToolTip(!typeToolTip);
  };
  const togglePriceToolTip = () => {
    setpriceToolTip(!priceToolTip);
  };
  const toggleCategoryToolTip = () => {
    setCategoryToolTip(!categoryToolTip);
  };

  const handleDelete = () => {
    var selectedresponsecodes = [];
    if (!isDoctor) {
      try {
        serviceData.categories.map((item) =>
          selectedresponsecodes.push(
            categoryBotResponseCodeMapping.filter(
              (code) => code.category === item
            )[0].responseCode
          )
        );
      } finally {
      }
    }
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Service}/${id}`,
      data: {
        deleter: 'dashboard',
        botResponseCode: selectedresponsecodes,
      },
    })
      .then((res) => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This service will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleSubmit = () => {
    var selectedresponsecodes = [];
    var selectedLuis = [];

    if (!isDoctor) {
      try {
        serviceData.categories.map((item) =>
          selectedresponsecodes.push(
            categoryBotResponseCodeMapping.filter(
              (code) => code.category === item
            )[0].responseCode
          )
        );
      } finally {
      }
    }
    if (isDoctor) {
      console.log('selectedcategories', serviceData.categories);
      try {
        serviceData.categories.map((item) =>
          selectedLuis.push({
            luisIntent: drBotResponseCodeMapping.filter(
              (code) => code.category === item
            )[0].intent,
            luisEntityKey: drBotResponseCodeMapping.filter(
              (code) => code.category === item
            )[0].entity_key,
            luisEntityValue: drBotResponseCodeMapping.filter(
              (code) => code.category === item
            )[0].entity_value,
          })
        );
      } finally {
      }
    }
    console.log(selectedLuis);
    if (id !== undefined) {
      var deletedcategories = [];
      var deletedresponsecodes = [];
      if (!isDoctor) {
        try {
          selectedcategories.map((item) =>
            serviceData.categories.filter((code) => code === item.value)
              .length === 0
              ? deletedcategories.push(item.value)
              : null
          );
        } finally {
        }
        try {
          deletedcategories.map((item) =>
            deletedresponsecodes.push(
              categoryBotResponseCodeMapping.filter(
                (code) => code.category === item
              )[0].responseCode
            )
          );
        } finally {
        }
      }
      const formmatedData = {
        ...serviceData,
        Updater: 'admin',
        botResponseCode: selectedresponsecodes,
        deleteBotResponseCode: deletedresponsecodes,
        categoryLuisSettings: selectedLuis,
      };

      console.log(formmatedData);

      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Service}/${id}`,
        data: formmatedData,
      })
        .then((res) => {
          //console.log(res.data);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else {
      const formmatedData = {
        ...serviceData,
        botResponseCode: selectedresponsecodes,
        categoryLuisSettings: selectedLuis,
      };
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Services}`,
        data: formmatedData,
      })
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
        {serviceData != undefined && (
          <ModalBody>
            {/* <pre>{JSON.stringify(serviceData, null, 2)}</pre> */}
            <Label className="mt-3">
              Title <i className="demo-icon simple-icon-info" id="titletip"></i>
            </Label>

            <Tooltip
              placement="right"
              isOpen={titleToolTip}
              target="titletip"
              toggle={toggleTitleToolTip}
            >
              A short title which will appear when users ask about the service
            </Tooltip>
            <Input
              type="text"
              onChange={handleChangeArr}
              value={serviceData.title[0].statement}
              name="title"
              maxLength={20}
              placeholder="$179 for Hair cut & colouring"
            />
            <Label className="mt-3">
              Type <i className="demo-icon simple-icon-info" id="typetip"></i>
            </Label>
            {typeTooltipText()}
            <Input
              type="select"
              name="type"
              value={serviceData.type}
              onChange={handleChange}
            >
              {qbot === false ? (
                <Fragment>
                  <option value="Package">Package</option>
                  <option value="Offer">Offer</option>
                  <option value="Service">Service</option>
                </Fragment>
              ) : (
                <Fragment>
                  <option value="RoomService">Room Service</option>
                  <option value="Housekeeping">Housekeeping</option>
                </Fragment>
              )}
            </Input>

            <Label className="mt-3">Response Message</Label>

            <Input
              type="textarea"
              onChange={handleChangeArr}
              value={serviceData.displayText[0].statement}
              name="displayText"
              placeholder="Experience a shampoo service, blissful head massage as well your choice of an all-over colour, a fresh style cut and ending with blow wave to finish off your new look"
            />

            <Label className="mt-3">Status</Label>
            <Input
              type="select"
              name="status"
              value={serviceData.status}
              onChange={handleChange}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Input>

            <Label className="mt-3">
              Categories{' '}
              {isDoctor && (
                <i
                  className="demo-icon simple-icon-info"
                  id="categoryToolTip"
                ></i>
              )}
            </Label>
            {categoryTooltipText()}
            {/* {qbot === false ? (
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                isMulti={true}
                name="form-field-name"
                value={selectedOptions}
                onChange={handleChangeMulti}
                options={salonCategoriesData}
              />
            ) : (
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                isMulti={true}
                name="form-field-name"
                value={selectedOptions}
                onChange={handleChangeMulti}
                options={GuestServicesCategoriesData}
              />
            )} */}
            {generatorCategorySelect()}
            {qbot === false ? (
              <Fragment>
                <Label className="mt-3">
                  Price Range{' '}
                  <i className="demo-icon simple-icon-info" id="pricetip"></i>{' '}
                </Label>
                {priceChangeTooltipText()}
              </Fragment>
            ) : (
              <Fragment>
                <Label className="mt-3">
                  Price{' '}
                  <i className="demo-icon simple-icon-info" id="pricetip"></i>{' '}
                </Label>
                <Tooltip
                  placement="right"
                  isOpen={priceToolTip}
                  target="pricetip"
                  toggle={togglePriceToolTip}
                >
                  You can chose your digital assistant to give customer a single
                  price.
                </Tooltip>
              </Fragment>
            )}

            {qbot === false ? (
              <div className="row">
                <div className="col-5">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                    <Input
                      required
                      name="priceRangeStart"
                      type="number"
                      min="0"
                      value={serviceData.priceRangeStart}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
                <div className="col-2 mt-3">to</div>
                <div className="col-5">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                    <Input
                      required
                      name="priceRangeEnd"
                      type="number"
                      min="0"
                      value={serviceData.priceRangeEnd}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </div>
            ) : (
              <InputGroup>
                <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                <Input
                  required
                  name="priceRangeStart"
                  type="number"
                  min="0"
                  value={serviceData.priceRangeStart}
                  onChange={handleChange}
                />
              </InputGroup>
            )}
            <Label className="mt-3">Tax Included in Price?</Label>
            <Input
              name="taxIncluded"
              type="select"
              onChange={handleChange}
              value={serviceData.taxIncluded}
            >
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Input>

            <Label className="mt-3">Price Conditions & Terms</Label>
            <Input
              type="textarea"
              onChange={handleChangeArr}
              value={serviceData.conditions[0].statement}
              name="conditions"
              placeholder="Price may vary based on length and thickness of hair"
            />
            <Label className="mt-3">Image</Label>
            <div className="text-center form-control">
              {serviceData.imageLink != '' ? (
                <div className="thumbnail">
                  <img
                    className="list-thumbnail responsive border-0"
                    src={serviceData.imageLink}
                  />
                  <a
                    href="#/"
                    className="remove"
                    data-dz-remove
                    onClick={() => handleRemoveImage()}
                  >
                    {' '}
                    <i className="glyph-icon simple-icon-trash" />{' '}
                  </a>
                </div>
              ) : (
                ''
              )}

              <Button
                color="secondary"
                className="mt-1"
                onClick={togglegallery}
              >
                Browse Gallery
              </Button>
            </div>
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          {id && (
            <Button color="danger" onClick={toggle}>
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
      {generateDeleteButton()}
      {ImageGalleryButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, domains } = settings;
  return {
    propertyId,
    domains,
  };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewService));
